export default __webpack_public_path__ + "static/media/ds_dark.90256347.svg";